var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pfixed custome"},[_c('a',{attrs:{"href":"http://zc.cjnep.net/sims/web/sign/info?word=9ac5a3c9c10f01ca9e2faee827ef15e6","target":"_blank"}},[_c('img',{attrs:{"src":require("../assets/images/index_09.png"),"alt":"","width":"122"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37fe8099","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Custome.vue
// module id = null
// module chunks = 